export const SWAP_TITLE = 'Safe Swap'
export const SWAP_ORDER_TITLE = 'Swap order'
export const LIMIT_ORDER_TITLE = 'Limit order'
export const TWAP_ORDER_TITLE = 'TWAP order'

export const SWAP_FEE_RECIPIENT = '0x63695Eee2c3141BDE314C5a6f89B98E62808d716'
